import { render, staticRenderFns } from "./UserTeamDetail.vue?vue&type=template&id=4c8aa122&scoped=true&"
import script from "./UserTeamDetail.vue?vue&type=script&lang=js&"
export * from "./UserTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserTeamDetail.vue?vue&type=style&index=0&id=4c8aa122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8aa122",
  null
  
)

export default component.exports